import { useEffect, useState } from "react";
import { Window } from "@progress/kendo-react-dialogs";
import { Button } from "reactstrap";
import CommonInput from "../../components/sys-common/CommonInput";
import TemplateService from "../../services/srv-mailTemplate/TemplateService";
import { useTranslation } from "react-i18next";
import LoadingPanel from "../../components/sys-toolbox/LoadingPanel";
import CommonEditor from "../../components/sys-common/CommonEditor";
import BasicDropDownList from "../../components/sys-common/BasicDropDownList";
import useEnumData from "../../utils/enums";
import {
  getAllInvitationTemplateParameters,
  getAllMailTemplateParameters,
} from "../../utils/common";
function TemplateAdd(props) {
  const { t } = useTranslation();
  const { DATAYESNO } = useEnumData();
  const [template, setTemplate] = useState({});
  const [loading, setLoading] = useState(false);
  const [templateParameters, setTemplateParameters] = useState([]);

  useEffect(() => {
    if (props.templateId === 0) {
      setTemplate({ body: "<p></p>" });
    } else {
      getData();
    }
  }, []);

  const getData = () => {
    setLoading(true);
    TemplateService.getTemplate(props.templateId).then((data) => {
      if (data.data) {
        setTemplate(data.data);
        setTemplateParameters(data?.additionalData?.parameters || []);
      }
      setLoading(false);
    });
  };

  const upsertTemplate = () => {
    TemplateService.upsertTemplate(template).then(() => {
      props.setIsAdded(true);
      props.toggleDialog();
    });
  };

  const allMailParameters = getAllMailTemplateParameters();

  const allInvitationParameters = getAllInvitationTemplateParameters();

  return (
    <Window
      title={props.title}
      onClose={props.toggleDialog}
      stage={window.innerWidth < 1000 ? "FULLSCREEN" : "DEFAULT"}
      initialHeight={"80vh"}
      initialWidth={"50%"}
      style={{
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        position: "fixed",
        zIndex: 10000,
      }}
    >
      {loading && <LoadingPanel />}
      <CommonInput
        id="code"
        label={t("template_name")}
        required={true}
        onChange={(e) => setTemplate({ ...template, code: e.value })}
        value={template?.code}
      ></CommonInput>
      <BasicDropDownList
        id="gecerli"
        label={t("valid")}
        data={DATAYESNO}
        required={true}
        value={template.gecerli}
        onChange={(e) =>
          setTemplate({ ...template, gecerli: e.target.value.value })
        }
      ></BasicDropDownList>
      <hr></hr>
      <CommonEditor
        value={template?.body}
        onChange={(e) => setTemplate({ ...template, body: e.html })}
      ></CommonEditor>

      {allMailParameters.length > 0 && (
        <div className="template-parameters mt-3 mb-3">
          <h6>{t("mail_parameters")}</h6>
          <div className="parameter-list p-2 bg-light border rounded">
            {allMailParameters.map((param, index) => (
              <span key={index} className="parameter-item">
                <code>#{param}#</code>: {t(`mail_template_parameters.${param}`)}
                {index < allMailParameters.length - 1 && ", "}
              </span>
            ))}
          </div>
        </div>
      )}

      {allInvitationParameters.length > 0 && (
        <div className="template-parameters mt-3 mb-3">
          <h6>{t("invitation_parameters")}</h6>
          <div className="parameter-list p-2 bg-light border rounded">
            {allInvitationParameters.map((param, index) => (
              <span key={index} className="parameter-item">
                <code>#{param}#</code>:{" "}
                {t(`invitation_template_parameters.${param}`)}
                {index < allInvitationParameters.length - 1 && ", "}
              </span>
            ))}
          </div>
        </div>
      )}

      <Button color="primary" type="button" size="sm" onClick={upsertTemplate}>
        <i className="fa fa-edit"></i> {t("save")}
      </Button>
    </Window>
  );
}

export { TemplateAdd };
